import { Skeleton } from '@heidi/design-system/skeleton';
import { useIntl } from 'react-intl';

import { heidi2OnboardingMessages } from './heidi2Onboarding.messages';

/**
 * Stands in for the form while it loads, at the height the form settles to, so
 * the dialog does not resize under the pointer once the real fields arrive.
 */
export const Heidi2BookDemoModalLoading = () => {
  const intl = useIntl();

  return (
    <div
      className="flex flex-col gap-4"
      role="status"
      aria-label={intl.formatMessage(heidi2OnboardingMessages.bookDemoLoadingAria)}
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <Skeleton className="h-16 w-full rounded-lg" />
        <Skeleton className="h-16 w-full rounded-lg" />
      </div>
      <Skeleton className="h-16 w-full rounded-lg" />
      <Skeleton className="h-16 w-full rounded-lg" />
      <Skeleton className="h-16 w-full rounded-lg" />
      <Skeleton className="h-16 w-full rounded-lg" />
      <div className="flex justify-end gap-2 pt-2">
        <Skeleton className="h-9 w-20 rounded-md" />
        <Skeleton className="h-9 w-20 rounded-md" />
      </div>
    </div>
  );
};
